
<template>
  <div class="drop-detail">
    <!-- 商品退费 -->
    <account-nav
      :type="'text'"
      :tabValue="'申请退课'"
      :slipper="false"
    ></account-nav>
    <div class="drop-detail__content">
      <div
        class="drop-detail__status"
        v-if="isRequestCompleted"
      >
        <div class="drop-detail__status-icon">
          <img
            v-if="isDropComplete(+productStatus)"
            src="@/assets/img/OrderDropDetail/status_complete.png"
          >
          <img
            v-else
            src="@/assets/img/OrderDropDetail/status_pending.png"
          >
        </div>
        <div class="drop-detail__status-text">
          <p class="drop-detail__status-title">{{productStatusDesc}}</p>
          <p class="drop-detail__status-desc">{{tips}}</p>
        </div>
      </div>
      <div class="drop-detail__order drop-detail-list">
        <div class="drop-detail-item">
          <p class="drop-detail-item__name">应退金额：</p>
          <p class="drop-detail-item__value drop-detail-item__value--highlight">{{`￥${refundPrice}`}} </p>
        </div>
        <div
          class="drop-detail-item sub"
          v-for="(channel, index) in refundChannels"
          :key="index"
        >
          <p class="drop-detail-item__value">{{channel}}</p>
        </div>
        <div
          class="drop-detail-item"
          v-if="Number(ppcPrice) && +productStatus === 3"
        >
          <p class="drop-detail-item__name">应退礼品卡：</p>
          <p class="drop-detail-item__value drop-detail-item__value--highlight">{{`￥${ppcPrice}`}} </p>
        </div>
        <div
          class="drop-detail-item"
          v-if="Number(ppcPrice) && +productStatus === 1"
        >
          <p class="drop-detail-item__name">退回礼品卡：</p>
          <p class="drop-detail-item__value drop-detail-item__value--highlight">{{`￥${ppcPrice}`}}<span style="color: #666;">，已到账</span></p>
        </div>
      </div>
      <div class="drop-detail__detail drop-detail-list">
        <div class="drop-detail-item">
          <p class="drop-detail-item__name">退课信息：</p>
          <p class="drop-detail-item__value">
            <span
              class="drop-detail-item__subject"
              v-if="subjectName"
            >{{subjectName}}</span>{{productName}}
          </p>
        </div>
        <div
          class="drop-detail-item"
          v-if="reasons"
        >
          <p class="drop-detail-item__name">退课原因：</p>
          <p class="drop-detail-item__value">{{reasons.join('/')}}</p>
        </div>
        <div class="drop-detail-item">
          <p class="drop-detail-item__name">申请时间：</p>
          <p class="drop-detail-item__value">{{applyTime}}</p>
        </div>
        <div class="drop-detail-item">
          <p class="drop-detail-item__name">温馨提示：</p>
          <p class="drop-detail-item__value">{{tipInfo.text}}<span
              class="drop-detail-link"
              v-if="tipInfo.linkUrl"
              @click="goDesc"
            >{{tipInfo.linkName}}</span></p>
        </div>
      </div>
      <div
        class="drop-detail__footer"
        v-if="+productStatus===3"
      >
        <div
          class="drop-detail-btn"
          @click="showDialog"
        >取消退课</div>
      </div>
    </div>
    <account-model
      class="drop-detail-dialog"
      v-show="isDialogShow"
      :has-header="false"
      :has-footer="false"
    >
      <div
        class="drop-detail-dialog__content"
        slot="content"
      >
        <i
          class="drop-detail-dialog__close el-icon-close"
          @click="closeDialog"
        ></i>
        <div class="drop-detail-dialog__text">
          确定取消退课吗？
        </div>
        <div class="drop-detail-dialog__footer">
          <div
            class="drop-detail-dialog-btn"
            @click="submitDrop"
          >取消</div>
          <div
            class="drop-detail-dialog-btn drop-detail-dialog-btn--highlight"
            @click="cancelDrop"
          >确定</div>
        </div>
      </div>
    </account-model>
  </div>
</template>

<script>
import axios from '~common/assets/js/ocenter-axios.js'
import accountNav from '@/components/sub/accountNav.vue'
import accountModel from '@/components/sub/accountModel.vue'

export default {
  name: 'OrderDrop',
  metaInfo: {
    title: '我的订单-退课详情'
  },
  components: {
    accountNav,
    accountModel
  },
  data () {
    return {
      isDialogShow: false,
      id: '',
      courseId: '',
      orderNum: '',
      type: '',
      isRequestCompleted: false,
      productStatus: 0,
      productStatusDesc: '',
      ppcPrice: '', // 应退礼品卡
      tips: '',
      refundPrice: 0,
      refundChannels: [],
      productName: '',
      subjectName: '',
      reasons: '',
      applyTime: '',
      tipInfo: {
        text: '',
        linkText: '',
        linkUrl: ''
      }
    }
  },
  created () {
    const {
      id,
      orderNum,
      type,
      productType
    } = this.$route.params
    this.id = id
    this.orderNum = orderNum
    this.type = type
    this.productType = productType
    this.courseId = this.$route.query.id
    this.getDetail()
  },
  methods: {
    getDetail () {
      axios.post(this.Service.Order.getDropDetail, {
        stuProductId: this.id,
        orderNum: this.orderNum,
        type: this.type
      }).then((res) => {
        if (res.status === 1) {
          this.isRequestCompleted = true
          const data = res.data
          this.productStatus = data.productStatus
          this.productStatusDesc = data.productStatusDesc
          this.tips = data.tips
          this.refundPrice = data.refundPrice
          this.refundChannels = data.refundChannels
          this.productName = data.productInfo.productName
          this.subjectName = data.productInfo.subjectName
          this.reasons = data.refundInfo.reasons
          this.applyTime = data.refundInfo.applyTime
          this.ppcPrice = data.ppcPrice
          this.tipInfo = {
            text: data.refundInfo.tips,
            linkName: data.refundInfo.linkName,
            linkUrl: data.refundInfo.linkUrl
          }
          this.$xesLogger.loadMsg({
            pageuid: '2',
            order_number_id: this.orderNum,
            course_id: this.courseId,
            type: this.isDropComplete(this.productStatus) ? 2 : 1
          })
        } else {
          this.$message.error(res.data)
        }
      }).catch(() => {
        this.$message.error('网络出错，刷新后重试')
      })
    },
    cancelDrop () {
      const params = {
        pageuid: '2',
        clickid: '2.3',
        order_number_id: this.orderNum,
        course_id: this.courseId
      }
      this.$xesLogger.clickMsg({
        params: params
      })
      axios.post(this.Service.Order.cancelReturnProduct, {
        productType: this.productType,
        stuProductIds: this.id
      }).then((res) => {
        if (res.status == 1) {
          // 取消退费成功，刷新订单列表
          this.$message.success('取消退课成功')
          this.$router.push('/MyOrders/list/0/1').catch(() => { })
        } else {
          this.$message.error(res.data)
        }
      }).catch(() => {
        this.$message.error('网络出错，刷新后重试')
      })
    },
    showDialog () {
      const params = {
        pageuid: '2',
        clickid: '2.1',
        order_number_id: this.orderNum,
        course_id: this.courseId
      }
      this.$xesLogger.clickMsg({
        params: params
      })
      this.isDialogShow = true
    },
    closeDialog () {
      this.isDialogShow = false
    },
    submitDrop () {
      const params = {
        pageuid: '2',
        clickid: '2.2',
        order_number_id: this.orderNum,
        course_id: this.courseId
      }
      this.$xesLogger.clickMsg({
        params: params
      })
      this.closeDialog()
    },
    goDesc () {
      const params = {
        pageuid: '2',
        clickid: '2.4',
        order_number_id: this.orderNum,
        course_id: this.courseId
      }
      this.$xesLogger.clickMsg({
        params: params
      })
      window.open(this.tipInfo.linkUrl)
    },
    isDropComplete (status) {
      return +status === 1
    }
  }
}
</script>

<style lang="less" scoped>
.drop-detail {
  min-height: 825px;
  &__status {
    display: flex;
    border-bottom: 1px solid #dcdcdc;
    padding: 30px;
    &-icon {
      flex: 0 0 44px;
      img {
        display: block;
        width: 44px;
        height: 44px;
      }
    }
    &-text {
      margin-left: 30px;
    }
    &-title {
      margin-bottom: 12px;
      font-size: 24px;
      line-height: 33px;
    }
    &-desc {
      font-size: 16px;
    }
  }
  &-list {
    font-size: 14px;
  }
  &-item {
    display: flex;
    align-items: flex-start;
    color: #666;
    &:nth-child(n + 2) {
      margin-top: 25px;
    }
    &__name {
      flex-shrink: 0;
      font-weight: 500;
    }
    &__value {
      flex: 1 1;
      font-weight: 400;
      vertical-align: middle;
      &--highlight {
        font-size: 14px;
        color: #f13232;
      }
    }

    &__subject {
      display: inline-block;
      min-width: 14px;
      height: 14px;
      border: 1px solid #f13232;
      margin-right: 3px;
      line-height: 14px;
      font-size: 12px;
      border-radius: 2px;
      color: #f13232;
      vertical-align: middle;
    }

    &.sub {
      margin-left: 70px;
    }
  }

  &__order {
    padding: 20px;
  }
  &__detail {
    border-top: 1px solid #dcdcdc;
    padding: 20px;
  }
  &__footer {
    padding: 120px 0;
  }

  &-link {
    cursor: pointer;
    color: #f13232;
    &:hover {
      color: #fa4747;
    }
  }
  &-btn {
    width: 90px;
    height: 32px;
    margin: 0 auto;
    font-size: 12px;
    line-height: 32px;
    text-align: center;
    background: #f13232;
    color: #fff;
    border-radius: 2px;
    cursor: pointer;
    &:hover {
      background: #fa4747;
    }
  }
  & &-dialog {
    & /deep/ .account-model-wrapper {
      width: 446px;
    }
    &__close {
      position: absolute;
      top: 10px;
      right: 0px;
      width: 14px;
      height: 14px;
      font-size: 14px;
      line-height: 14px;
    }
    &__content {
      position: relative;
    }
    &__text {
      display: flex;
      height: 165px;
      font-size: 16px;
      color: #333;
      align-items: center;
      justify-content: center;
    }
    &-btn {
      display: inline-block;
      box-sizing: border-box;
      width: 130px;
      height: 40px;
      border: 1px solid #dedede;
      font-size: 14px;
      line-height: 38px;
      text-align: center;
      color: #333;
      border-radius: 1px;
      cursor: pointer;
      &:nth-child(n + 2) {
        margin-left: 26px;
      }
      &--highlight {
        color: #fff;
        background: #f13232;
        border: 1px solid #f13232;
        &:hover {
          background: #fa4747;
          border: 1px solid #fa4747;
        }
      }
    }
    &__footer {
      text-align: center;
      padding-bottom: 22px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// module/order/src/pages/OrderDropDetail.vue